import { render, staticRenderFns } from "./serviceBottom.vue?vue&type=template&id=58a29903&scoped=true"
import script from "./serviceBottom.vue?vue&type=script&lang=js"
export * from "./serviceBottom.vue?vue&type=script&lang=js"
import style0 from "./serviceBottom.vue?vue&type=style&index=0&id=58a29903&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a29903",
  null
  
)

export default component.exports